export default __webpack_public_path__ + "static/media/print-label-first-position.838cd58c.svg";